// Import firebase app
import firebase from 'firebase/app'
// import firebase database
import 'firebase/firestore'

// firebase config codes
const firebaseConfig = {
    apiKey: "AIzaSyDJ2jIGzbYO1d80hT644csUayamPQxM-P8",
    authDomain: "online-articleshare.firebaseapp.com",
    databaseURL: "https://online-articleshare.firebaseio.com",
    projectId: "online-articleshare",
    storageBucket: "online-articleshare.appspot.com",
    messagingSenderId: "918761101428",
    appId: "1:918761101428:web:86195f291fef82d01cd921",
    measurementId: "G-52FDJK4T9K"
};
  
// initialize firebase app to the config
const firebaseApp = firebase.initializeApp(firebaseConfig)
firebaseApp.firestore().settings({}) // use firebase firestore

export default firebaseApp.firestore()